import { SagaIterator } from "redux-saga";
import { mapMyQuestionnaire } from "src/modules/MyQuestionnaire/helpers";
import { getCall } from "src/services";

type GetMyQuestionnaire = SagaIterator | Promise<unknown>;

export function* getMyQuestionnaire(questionnaireId: string, lng: string): GetMyQuestionnaire {
  const questionnaire = yield getCall({
    url: `/v1/feedback/talk/questionnaire/${questionnaireId}`,
    params: { languageCode: lng }
  });
  return mapMyQuestionnaire(questionnaire);
}

export function* getMyPeerQuestionnaire(questionnaireId: string, lng: string): GetMyQuestionnaire {
  const questionnaire = yield getCall({
    url: `/v1/feedback/talk/questionnaire/${questionnaireId}`,
    params: { languageCode: lng }
  });
  return mapMyQuestionnaire(questionnaire);
}
